import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b578122"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overview"
}
const _hoisted_2 = { class: "mb-20" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Labels", -1))
const _hoisted_7 = { class: "label-wrapper" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "no-overview"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No information added yet", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "d-overview"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Labels", -1))
const _hoisted_15 = { class: "label-wrapper" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "mb-20 description" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 2,
  class: "no-overview"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No information added yet", -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_app_label = _resolveComponent("app-label")!
  const _component_drive_share_toggle = _resolveComponent("drive-share-toggle")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$localize('drive.view.case.overview.tab.title')), 1),
          (!_ctx.skeleton)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createElementVNode("span", {
                  innerHTML: _ctx.descriptionWithLink(_ctx.description)
                }, null, 8, _hoisted_4),
                (!_ctx.showAllDescription && _ctx.description.length >= 125)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllDescription = true)),
                      style: {"text-decoration":"underline"}
                    }, " More... "))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 1,
                animated: "",
                style: {"--el-skeleton-color":"#AFBEC7","height":"18px"}
              }, {
                template: _withCtx(() => [
                  _createVNode(_component_el_skeleton_item, { variant: "text" })
                ]),
                _: 1
              }))
        ]),
        (_ctx.driveStore.currentCase?.labels?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driveStore.currentCase.labels, (label) => {
                  return (_openBlock(), _createBlock(_component_app_label, {
                    key: label.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _ctx.descriptionWithLink(label.name)
                      }, null, 8, _hoisted_8)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.noOverview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isPublicToggle && !_ctx.skeleton && !_ctx.isPreview)
          ? (_openBlock(), _createBlock(_component_drive_share_toggle, { key: 2 }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        (_ctx.driveStore.currentCase?.labels?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driveStore.currentCase.labels, (label) => {
                  return (_openBlock(), _createBlock(_component_app_label, {
                    key: label.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: _ctx.descriptionWithLink(label.name)
                      }, null, 8, _hoisted_16)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$localize('drive.view.case.overview.tab.title')), 1),
          (!_ctx.skeleton)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                _createElementVNode("span", {
                  innerHTML: _ctx.descriptionWithLink(_ctx.description)
                }, null, 8, _hoisted_19),
                (!_ctx.showAllDescription && _ctx.description.length >= 125)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAllDescription = true)),
                      style: {"text-decoration":"underline"},
                      class: "more"
                    }, " More... "))
                  : (_ctx.showAllDescription)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAllDescription = false)),
                        style: {"text-decoration":"underline"},
                        class: "more"
                      }, " Hide description "))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 1,
                animated: "",
                style: {"--el-skeleton-color":"#AFBEC7","height":"18px"}
              }, {
                template: _withCtx(() => [
                  _createVNode(_component_el_skeleton_item, { variant: "text" })
                ]),
                _: 1
              }))
        ]),
        (_ctx.isPublicToggle && !_ctx.skeleton && !_ctx.isPreview)
          ? (_openBlock(), _createBlock(_component_drive_share_toggle, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.noOverview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
          : _createCommentVNode("", true)
      ]))
}